module.exports = __webpack_public_path__ + "static/media/check_circle_outline-purple-18dp.4a2fed4f.svg";